import * as v from 'valibot';

/**
 * CCML likelihood buckets attached after scoring. Shared by the BFF odds map
 * and the paid/organic client parsers.
 */
export const ApprovalLikelihoodSchema = v.picklist([
  'EXCELLENT_AO',
  'GOOD_AO',
  'FAIR_AO',
  'POOR_AO',
]);

export type ApprovalLikelihood = v.InferOutput<typeof ApprovalLikelihoodSchema>;

export const ApprovalLikelihood = {
  EXCELLENT_AO: 'EXCELLENT_AO',
  GOOD_AO: 'GOOD_AO',
  FAIR_AO: 'FAIR_AO',
  POOR_AO: 'POOR_AO',
} as const satisfies Record<ApprovalLikelihood, ApprovalLikelihood>;

/** One scored card in the public odds map (organic GET and paid POST). */
export const ApprovalOddsItemSchema = v.object({
  id: v.string(),
  score: v.number(),
  approvalLikelihood: ApprovalLikelihoodSchema,
});

export type ApprovalOddsItem = v.InferOutput<typeof ApprovalOddsItemSchema>;

export const ApprovalOddsMapSchema = v.record(v.string(), ApprovalOddsItemSchema);

export type ApprovalOddsMap = v.InferOutput<typeof ApprovalOddsMapSchema>;
